import { Injectable } from '@angular/core';
import { ButtonItem } from '../../../../shared/button/button.model';
import { PickManagementDataService } from './pick-management-data.service';
import { PickManagementActionService } from './pick-management-action.service';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { DetailedEntityButtonService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-button.service';

@Injectable()
export class PickManagementButtonService extends DetailedEntityButtonService {

  private pmDataService: PickManagementDataService;
  private pmActionService: PickManagementActionService;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  public setDependentService(dataService: PickManagementDataService, actionService: PickManagementActionService) {
    this.pmDataService = dataService;
    this.pmActionService = actionService;
  }

  public handleButtonActionForEdit(action: any) {
    let needYesNoConfirmation = false;
    switch (action) {
      case 'Save': {
        needYesNoConfirmation = false;
        break;
      }
    }
    if (!(needYesNoConfirmation)) {
      this.performButtonActions(action);
    }

  }

  // this method sets the visible and enabled flags for the buttons based on the display mode and the po status
  protected getAllButtons(): any {
    return {
      'search-table': [
        new ButtonItem('Export', this.resourceService.get('lbl_export'), 'pick_ser_export', 'icon-export.svg',
          [
            new ButtonItem('Export as Excel', this.resourceService.get('btn_exportExcel'), 'pick_ser_export', 'icon-export.svg', []),
            new ButtonItem('Export as CSV', this.resourceService.get('btn_exportCSV'), 'pick_ser_export', 'icon-export.svg', [])
          ])
      ],
      'detail-main': [
        new ButtonItem('Edit', this.resourceService.get('btn_edit'), 'pick_edit', 'icon_edit.svg', []),
        new ButtonItem('Save', this.resourceService.get('btn_save'), '', 'icon_save.svg', [])
      ],
      'detail-table': [
        //[LFWM-3529] export button added to the pick management detail page
        new ButtonItem('Export_det', this.resourceService.get('lbl_export'), 'pick_detail_export', 'icon-export.svg',
        [
          new ButtonItem('Export_as_Excel', this.resourceService.get('btn_exportExcel'), 'pick_detail_export', 'icon-export.svg', []),
          new ButtonItem('Export_as_CSV', this.resourceService.get('btn_exportCSV'), 'pick_detail_export', 'icon-export.svg', [])
        ]),
        new ButtonItem('Add Row', this.resourceService.get('lbl_AddNewRow'), 'pick_add', 'icon-add-new-row.svg', []),
        new ButtonItem('Delete_Main', this.resourceService.get('btn_delete'), 'pick_del', 'icon_delete.svg', [
          new ButtonItem('Delete Line Item(s)', this.resourceService.get('btn_delete_line'), 'pick_del', 'icon_delete.svg', []),
          new ButtonItem('Delete All Line Items', this.resourceService.get('btn_delete_all_lines'), 'pick_del', 'icon_delete.svg', []),
        ]),
        new ButtonItem('UnAllocate_Main', this.resourceService.get('btn_unallocate'), 'pick_unalloc', 'icon_unallocate.svg', [
          new ButtonItem('UnAllocate Line Item(s)', this.resourceService.get('btn_unallocate_line'),
            'pick_line_unalloc', 'icon_unallocate.svg', []),
          new ButtonItem('UnAllocate All Line Items', this.resourceService.get('btn_unallocate_all_lines'),
            'pick_all_unalloc', 'icon_unallocate.svg', []),
            new ButtonItem('UnAllocate By Wave', this.resourceService.get('btn_unallocate_by_wave'),
            'pick_wav_unalloc', 'icon_unallocate.svg', []),
          new ButtonItem('UnAllocate By Load', this.resourceService.get('btn_unallocate_by_load'),
            'pick_load_unalloc', 'icon_unallocate.svg', []),
        ]),
        new ButtonItem('Delete_PreAllocate', this.resourceService.get('btn_delete'), 'pick_del', 'icon_delete.svg', [
          new ButtonItem('Delete Line Item(s)', this.resourceService.get('btn_delete_line'), 'pick_del', 'icon_delete.svg', [])
        ])
      ],
    };
  }

  public initializeButtons() {

    // tslint:disable-next-line:triple-equals
    // [LFWM-2406] - button array should be empty when order status 9-shipped.
    if (this.pmDataService.getOrderStatus() === '9') {
      this.rebuildButtonArray(this.userButtonMap['detail-main'],
      [
      ]);
    this.rebuildDetailButtonPanel([
    ]);
    } else {
    if (this.pmDataService.searchServices[this.pmDataService.selectedTab].getDisplayMode() === 'V') {
      // tslint:disable-next-line:triple-equals
      // LFWM-2930 first time selectedtab value is 0 and if click to a different tab and click back it will be '0'.
      // So converting value to int using parseInt() and comparing value with 0.
      if (parseInt(this.pmDataService.selectedTab, 10) === 0) {
        this.rebuildButtonArray(this.userButtonMap['detail-main'],
          [
            'Edit'
          ]);
        this.rebuildDetailButtonPanel([         
          // LFWM-2040 Wave Control Pick Management add unallocate button - Remove Delete button in Allocated tab
          // 'Delete_Main',
          'UnAllocate_Main'
        ]);
      // tslint:disable-next-line:triple-equals
      } else if (this.pmDataService.selectedTab === '1') {
        this.rebuildButtonArray(this.userButtonMap['detail-main'],
          [
          ]);
        this.rebuildDetailButtonPanel([
          'Delete_PreAllocate'
        ]);
      // tslint:disable-next-line:triple-equals
      } else if (this.pmDataService.selectedTab === '2') {
        this.rebuildButtonArray(this.userButtonMap['detail-main'],
          [
            'Edit'
          ]);
        this.rebuildDetailButtonPanel([
          'Delete_Main'
        ]);
      }       
       else {
        this.rebuildButtonArray(this.userButtonMap['detail-main'],
          []);
        this.rebuildDetailButtonPanel([]);
      }
    } else {
      // tslint:disable-next-line:triple-equals
      if (parseInt(this.pmDataService.selectedTab, 10) === 0 || this.pmDataService.selectedTab === '2') {
        this.rebuildButtonArray(this.userButtonMap['detail-main'],
          [
            'Save'
          ]);
      }
      // tslint:disable-next-line:triple-equals
      if (parseInt(this.pmDataService.selectedTab ,10) === 0) {
      this.rebuildDetailButtonPanel([
        'Add Row',        
        // LFWM-2040 Wave Control Pick Management add unallocate button - Remove Delete button in Allocated tab
        // 'Delete_Main',
        'UnAllocate_Main'
      ]);
     // tslint:disable-next-line:triple-equals
     } else if (this.pmDataService.selectedTab === '1') {
      this.rebuildDetailButtonPanel([
        'Delete_PreAllocate'
      ]);
     } else if (this.pmDataService.selectedTab === '2') {
      this.rebuildDetailButtonPanel([
        'Delete_Main'
      ]);
     } else {
      this.rebuildDetailButtonPanel([        
      ]);
     }
    }
  }
  }
  public performButtonActions(action: any) {
    this.alertService.clearAll();
    switch (action) {
      case 'Edit': {
        this.pmActionService.editPage();
        break;
      }

      case 'Save': {
        this.pmActionService.successMsg = 'msg_save_succ';
        const saveObs = this.pmActionService.savePage();
        if (saveObs) {
          saveObs.subscribe((response) => {
            if (response.statusCode === 200) {
              const successMsg = 'msg_save_succ';
              this.alertService.clearAll().success(this.resourceService.get(successMsg));
              this.pmDataService.searchServices[this.pmDataService.selectedTab].performSearch();
              this.pmDataService.searchServices[this.pmDataService.selectedTab].clearMarkerFlags();
              this.navService.preventNavigation = false;
              if (this.pmDataService.searchServices[this.pmDataService.selectedTab].getDisplayMode() !== 'V') {
                this.pmDataService.searchServices[this.pmDataService.selectedTab].setDisplayMode('V');
                this.initializeButtons();
              }
            } else {
              this.alertService.clearAll();
              this.alertService.error(this.resourceService.translateServerResponse(response.statusMessage));
            }
          }, (error) => {
            this.alertService.error(this.resourceService.translateServerResponse(error));
          });
        }
        break;
      }

      case 'Delete Line Item(s)': {
        this.pmActionService.dialogMsg = this.resourceService.get('msg_del_detail');
        this.pmActionService.successMsg = this.resourceService.get('msg_del_itm_succ');
        this.pmActionService.errorMsg = this.resourceService.get('msg_sel_detail');
        this.pmActionService.deleteLineItem();
        break;
      }
      case 'Delete All Line Items': {
        this.pmActionService.dialogMsg = this.resourceService.get('msg_del_all_detl');
        this.pmActionService.successMsg = this.resourceService.get('msg_del_all_succ');
        this.pmActionService.errorMsg = this.resourceService.get('msg_no_detail');
        this.pmActionService.deleteAllLineItems();
        break;
      }
      case 'UnAllocate Line Item(s)': {
        this.pmActionService.dialogMsg = this.resourceService.get('msg_unalc_dtl');
        this.pmActionService.successMsg = this.resourceService.get('msg_unalc_succ');
        this.pmActionService.errorMsg = this.resourceService.get('msg_sel_detail');
        this.pmActionService.unallocateLineItem();
        break;
      }
      case 'UnAllocate All Line Items': {
        this.pmActionService.dialogMsg = this.resourceService.get('msg_unalc_all_dtl');
        this.pmActionService.successMsg = this.resourceService.get('msg_unalc_all_succ');
        this.pmActionService.errorMsg = this.resourceService.get('msg_no_detail');
        this.pmActionService.unallocateAllLineItem();
        break;
      }
      case 'Export as Excel': {
        this.exportAsExcel();
        break;
      }
      case 'Export as CSV': {
        this.exportAsCSV();
        break;
      }
      case 'Export_as_Excel': {
        this.exportAsExcelForDetail();
        break;
      }
      case 'Export_as_CSV': {
        this.exportAsCSVForDetail();
        break;
      }      
      case 'UnAllocate By Wave': {
        this.pmActionService.unallocateByWavekey();
        break;
      }
      case 'UnAllocate By Load': {
        this.pmActionService.unallocateByLoadkey();
        break;
      }
    }
  }
  public rebuildDetailButtonPanel(buttonArray: Array<string>) {
    // [JIRA LFWM-611 fixes]-If there is no detail line items in detail grid, then there is no need of any buttons
    if (!this.pmDataService.searchServices[this.pmDataService.selectedTab] ||
      !this.pmDataService.searchServices[this.pmDataService.selectedTab].getPagedData() ||
      !this.pmDataService.searchServices[this.pmDataService.selectedTab].getPagedData().pageRows ||
      this.pmDataService.searchServices[this.pmDataService.selectedTab].getPagedData().pageRows.length <= 0) {
      if (this.pmDataService.searchServices[this.pmDataService.selectedTab].getDisplayMode() === 'E') {
        // tslint:disable-next-line:triple-equals
        if (parseInt(this.pmDataService.selectedTab, 10) === 0) {
          this.rebuildButtonArray(this.userButtonMap['detail-table'],
            ['Add Row']);
        }
      } else {
        this.rebuildButtonArray(this.userButtonMap['detail-table'],
          []);
      }
    } else {
      this.rebuildButtonArray(this.userButtonMap['detail-table'], buttonArray);
        //[LFWM-3529] export button should display in a view mode and when pageRows is > 0
        if(this.pmDataService.searchServices[this.pmDataService.selectedTab].getDisplayMode() === 'V'){
          if(this.pmDataService.selectedTab === '1'){
            this.rebuildButtonArray(this.userButtonMap['detail-table'], ['Export_det','Delete_PreAllocate']);
          } else this.rebuildButtonArray(this.userButtonMap['detail-table'], ['Export_det']);
        }
    }
  }

  protected exportAsExcel() {
    this.pmActionService.exportData(this.dataService.searchService, 'excel');
    // calls pmActionService.exportdata since this class doesn't extend to any base class    
  }

  protected exportAsCSV() {
    this.pmActionService.exportData(this.dataService.searchService, 'csv');
  }


  protected exportAsCSVForDetail(){
    this.pmActionService.exportData(this.pmDataService.searchServices[this.pmDataService.selectedTab], 'csv');
  }

  protected exportAsExcelForDetail(){
    this.pmActionService.exportData(this.pmDataService.searchServices[this.pmDataService.selectedTab], 'excel');    
  }
    

}




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/outbound/pick-management/services/pick-management-button.service.ts